var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOzon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 474.7",
    style: {
      enableBackground: "new 0 0 1080 474.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#005BFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.3,277.3h-64.7L496.2,168c1.8-2.4,1.3-5.9-1.1-7.7c-0.9-0.7-2.1-1.1-3.3-1.1H372.3 c-10.5,0-19.1,8.6-19.1,19.1s8.6,19.1,19.1,19.1h53.7l-82.9,109.4c-1.9,2.4-1.4,5.8,1,7.7c1,0.8,2.2,1.2,3.4,1.1h130.7 c10.5-0.5,18.6-9.5,18.1-20.1c-0.5-9.8-8.3-17.6-18.1-18.1V277.3z M895.9,159.2c-10.5,0-19.1,8.6-19.1,19.1v64.1l-103.2-81.9 c-2.3-1.9-5.8-1.6-7.7,0.8c-0.8,1-1.2,2.2-1.2,3.5v131.7c0,10.5,8.6,19.1,19.1,19.1s19.1-8.5,19.1-19.1v-64.1l103.2,82 c2.4,1.9,5.9,1.5,7.8-0.9c0.8-1,1.2-2.2,1.2-3.4V178.3C915,167.7,906.5,159.2,895.9,159.2 M622.8,280.9c-43.7,0-76.3-23-76.3-43.6 c0-20.6,32.7-43.6,76.3-43.6c43.7,0,76.3,23,76.3,43.6C699.1,257.9,666.6,280.9,622.8,280.9 M622.8,155.5 c-63.2,0-114.5,36.6-114.5,81.8c0,45.2,51.3,81.8,114.5,81.8s114.5-36.6,114.5-81.8C737.3,192.1,686,155.5,622.8,155.5 M246.9,281 c-24.1,0-43.7-19.5-43.7-43.6c0-24.1,19.5-43.7,43.6-43.7c24.1,0,43.7,19.5,43.7,43.6v0.1C290.5,261.4,271,280.9,246.9,281  M246.9,155.5c-45.2,0-81.8,36.6-81.9,81.8c0,45.2,36.6,81.8,81.8,81.9c45.2,0,81.8-36.6,81.9-81.8c0,0,0-0.1,0-0.1 C328.6,192.1,292,155.5,246.9,155.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzon);
export default __webpack_public_path__ + "static/media/ozon.002cc06a1c459b4f15d00539193f0a48.svg";
export { ForwardRef as ReactComponent };